import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const Room = () => {
  const navigate = useNavigate();
  const [roomDetails, setRoomDetails] = useState({
    roomNumber: '',
    roomRent: '',
    locationurl: '',
    photos: ['', '', ''],
    phonenumber: '',
    whatsappenabled: false,
    AC : false,
    Wifi: false,
     Electricity: false,
     RO : false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Use the `checked` property for checkboxes
    setRoomDetails((prevDetails) => ({
      ...prevDetails,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageChange = (index, e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const base64Image = event.target.result;
        const newPhotos = [...roomDetails.photos];
        newPhotos[index] = base64Image;

        setRoomDetails((prevDetails) => ({
          ...prevDetails,
          photos: newPhotos,
        }));
      };

      reader.readAsDataURL(files[0]);
    }
  };

  const handleCreateRoom = async () => {
    // Validate required fields
    if (!roomDetails.roomNumber || !roomDetails.roomRent || !roomDetails.phonenumber || !roomDetails.photos[0] ||!roomDetails.locationurl) {
      toast.error('Please Fill All The Required  Details');
      return;
    }

    try {
      const response = await fetch('https://pgdost.onrender.com/api/room', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roomemail: localStorage.getItem('email'),
          pgName: roomDetails.roomNumber,
          roomRent: roomDetails.roomRent,
          locationurl: roomDetails.locationurl,
          phno: roomDetails.phonenumber,
          whatsappenabled: roomDetails.whatsappenabled,
          AC : roomDetails.AC,
          Electricity: roomDetails.Electricity,
          Wifi: roomDetails.Wifi,
          RO : roomDetails.RO,

          photos: roomDetails.photos,
        }),
      });

      if (response.ok) {
        // Room request created successfully
        console.log('Room request created successfully');
        navigate('/home');
        // You can redirect the user or perform any other actions here
      } else {
        // Error in creating room request
        console.error('Error creating room request');
      }
    } catch (error) {
      console.error('Error creating room request:', error);
    }
  };
  useEffect(() => {
    if (localStorage.getItem('email') == null && localStorage.getItem('password') == null) {
      navigate('/login');
    }
  }, []);

  return (
    <div className="flex justify-center p-8">
      {/* Form Input Section */}
      <div className="w-full lg:w-1/2 p-4 bg-white rounded-lg shadow-md">
        <h2 className="text-3xl font-semibold mb-6 text-center">Add Room Details</h2>


        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">PG Name<span className="text-red-500">*</span></label>
          <input
            type="text"
            name="roomNumber"
            value={roomDetails.roomNumber}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Room Rent<span className="text-red-500">*</span></label>
          <input
            type="text"
            name="roomRent"
            value={roomDetails.roomRent}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Phone Number<span className="text-red-500">*</span></label>
          <input
            type="Number"
            name="phonenumber"
            value={roomDetails.phonenumber}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="whatsappenabled"
              checked={roomDetails.whatsappenabled}
              onChange={handleChange}
              className="mr-2"
            />
            Enable WhatsApp
          </label>
        </div>
        <div className="mb-4">
          <label className=" text-sm font-medium text-gray-700">location<span className="text-red-500">*</span></label>
          <input
            type="text"
            name="locationurl"
            value={roomDetails.locationurl}
            onChange={handleChange}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>
        {/* Image Input Fields */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Main Image<span className="text-red-500">*</span></label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(0, e)}
            className="mt-1 p-2 border rounded w-full"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Image 2</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(1, e)}
            className="mt-1 p-2 border rounded w-full"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Image 3</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(2, e)}
            className="mt-1 p-2 border rounded w-full"
          />
        </div>
        
        <label className='block text-sm font-medium text-gray-700 mb-4'> Room functionalities : 
        {/* Checkbox for WiFi */}
        
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="AC"
              checked={roomDetails.AC}
              onChange={handleChange}
              className="mr-2"
            />
            AC
          </label>
        </div>
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="Wifi"
              checked={roomDetails.Wifi}
              onChange={handleChange}
              className="mr-2"
            />
            WiFi
          </label>
        </div>

        {/* Checkbox for Electricity Backup */}
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="Electricity"
              checked={roomDetails.Electricity}
              onChange={handleChange}
              className="mr-2"
            />
            Electricity Backup
          </label>
        </div>

        {/* Checkbox for RO Purifier */}
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="RO"
              checked={roomDetails.RO}
              onChange={handleChange}
              className="mr-2"
            />
            RO Purifier
          </label>
        </div>
        </label>
        <button
          onClick={handleCreateRoom}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700"
        >
          Create Your Room Request
        </button>
      </div>

      {/* Preview Section */}
      <div className="hidden lg:block w-1/2 p-4">
        <h2 className="text-3xl font-semibold mb-6 text-center">Your Post Preview</h2>
        <div className="max-w-md mx-auto bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden">
          <img
            className="w-full h-40 object-cover rounded-t-lg"
            src={roomDetails.photos[0] || 'placeholder-image.jpg'}
            alt={`Room image`}
          />
          <div className="px-6 py-4">
            <h5 className="text-xl font-semibold tracking-tight text-gray-900">
              {roomDetails.roomNumber || 'PG Name'}
            </h5>
            <div className="flex items-center mt-2.5 mb-4 space-x-2">
              {/* ... (other buttons or details) */}
            </div>
            <div className="flex items-center justify-between">
              <span className="text-3xl font-bold text-gray-900">
                ₹{roomDetails.roomRent || 'Room Rent'}/month
              </span>
              <a href={roomDetails.locationUrl} target="_blank" rel="noopener noreferrer" className="btn-blue">
                See More
              </a>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

export default Room;